<template>
  <div class="h-full relative">
    <MissionTextMode ref="chatTextModRef" />
  </div>
</template>
